import React from 'react';
import { useStyles } from './styles';
import { Box, Button, Alert, Stack } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import warning from '../../assets/warning.png';


export const AdditionalPaymentAlert = (props) => {

  const classes = useStyles();

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <Dialog fullScreen={fullScreen} PaperProps={{ classes: { root: classes.dialogStyle } }} onClose={props.handleClose} open={true}>
     
      <Box className={classes.root}>
         <IconButton onClick={props.handleClose} className={classes.closeIcon}>
          <CancelIcon />
         </IconButton>
          <Box className={classes.cardBody}>
            <Box className={classes.statusContainer}>
              <p className={classes.statusTitle1}>
              <img src={warning} className={classes.image} />
          </p>
          {props.single ? 
           <p className={classes.statusTitle2}>
             We see that the designated additional principal amount is within $5,000 of your unpaid principal balance. If you intend to pay off your loan, please select a Request Payoff quote. If you are intending to make a principal prepayment, please continue with your payment.
             </p> :
            <p className={classes.statusTitle2}>
             We see that one or more of your loan accounts is within $5,000 of your unpaid principal balance. Please select Request Payoff if you intend to pay off your loan. If you are intending to make a principal prepayment, please continue with your payment.
            </p>
          }
          </Box>
        </Box>
        <Box className={classes.cardFooter}>
          <Box className={classes.footerItem}>
               <Button className={classes.swtichBack}
                  onClick={props.routeToRequestPayOff}>
                  REQUEST PAYOFF
                </Button>
           
          </Box>
          <Box className={classes.footerItem}>
            <Button
              variant='contained'
              color='primary'
              className={classes.btn}
              onClick={props.handleCloseAlert}
            >CONTINUE</Button>
          </Box>
        </Box>
      </Box> 
     
    </Dialog>
  )
}
